import {useEffect} from 'react';

/**
 * Expands tree to the given path (lazy loads folders along the way)
 */
export const useExpandToPath = ({
   open,
   currentPath,
   loadFolder,
   setExpanded,
   setSelected,
}: {
   open: boolean;
   currentPath?: string;
   loadFolder: (path: string) => Promise<void>;
   setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
   setSelected: React.Dispatch<React.SetStateAction<string>>;
}) => {
   useEffect(() => {
      if (!open || !currentPath) return;

      const expandPath = async () => {
         // Split path into segments: /a/b/c -> ['a','b','c']
         const parts = currentPath.split('/').filter(Boolean);
         parts.pop();

         let acc = '';
         const paths: string[] = ['/'];

         // Build full paths: '/', '/a', '/a/b', '/a/b/c'
         for (const part of parts) {
            acc += `/${part}`;
            paths.push(acc);
         }

         // Sequential loading (important for lazy tree)
         for (const path of paths) {
            await loadFolder(path);
         }

         setExpanded(paths);
         setSelected(currentPath);
      };

      expandPath();
   }, [open, currentPath]);
};
